var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3",class:("text-" + _vm.align)},[_c('div',{staticClass:"is-loading large dark",class:("" + _vm.theme)})])}
var staticRenderFns = []

export { render, staticRenderFns }